import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PartialWorkout} from '../../../../Models/PartialWorkout';
import {PresenterProps, withPresenter} from '../../../../Support/with_presenter';
import {ExportButtonPresenter} from './ExportButtonPresenter';

interface OwnProps {
    partialWorkout: PartialWorkout;
    type: 'csv' | 'json' | 'tcx';
}

const ExportButtonComponent: FunctionComponent<OwnProps & PresenterProps<ExportButtonPresenter>> = observer(
    ({presenter, type}) => {
        switch (presenter.status) {
            case 'idle':
                return (
                    <button className="btn btn-primary" onClick={() => presenter.requestExport()}>
                        {type.toUpperCase()}
                    </button>
                );
            case 'exporting':
                return (
                    <button className="btn btn-primary">
                        <div className="spinner-border spinner-border-sm text-light" role="status"></div>
                    </button>
                );
            case 'exported':
                return (
                    <button className="btn btn-primary">
                        <i className="bi bi-check" />
                    </button>
                );
        }

        return null;
    },
);

export const ExportButton = withPresenter<ExportButtonPresenter, OwnProps>(
    (props, component) => new ExportButtonPresenter(props.partialWorkout.id, props.type, component.network.export),
    ExportButtonComponent,
);
